import React, { useState } from 'react';
import { HelpCircle, X } from 'lucide-react';
import { SupportTicketForm } from './SupportTicketForm';
import { Button } from '../packages/ui';

/**
 * SupportButton — fixed-position "Contact support" button that opens a
 * compact form. Rendered from Layout so it sits on every authenticated
 * page; unauthenticated pages don't need it (auth/marketing flows are
 * narrow enough that a contact link in the footer is fine).
 *
 * The goal is "let users get words to us without leaving what they're
 * doing"; ticket history lives on /help, which uses the same form.
 */
export function SupportButton() {
    const [open, setOpen] = useState(false);
    // A send in flight keeps the dialog open: closing would unmount the form
    // and lose the typed text if the POST then fails.
    const [busy, setBusy] = useState(false);
    const close = () => { if (!busy) setOpen(false); };
    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                aria-label="Contact support"
                style={{
                    position: 'fixed', right: 28, bottom: 88, zIndex: 90,
                    width: 48, height: 48, borderRadius: '50%',
                    background: 'var(--accent)', color: 'var(--on-accent)',
                    border: 'none', cursor: 'pointer',
                    boxShadow: 'var(--shadow-md)',
                    fontSize: 22, lineHeight: 1,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}
            >
                <HelpCircle size={24} aria-hidden="true" />
            </button>

            {open && (
                <div
                    data-testid="support-backdrop"
                    onClick={close}
                    style={{
                        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100,
                    }}
                >
                    <div
                        onClick={e => e.stopPropagation()}
                        style={{
                            background: 'var(--color-surface)', borderRadius: 'var(--radius-lg)',
                            padding: 'var(--space-5)', minWidth: 380, maxWidth: 520, width: '90%',
                            border: '1px solid var(--color-border)',
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 'var(--space-3)' }}>
                            <h3 style={{ margin: 0 }}>Contact support</h3>
                            <Button type="button" variant="ghost" size="sm" onClick={close} disabled={busy} aria-label="Close"><X size={16} aria-hidden="true" /></Button>
                        </div>
                        <p style={{ color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)', marginBottom: 'var(--space-3)' }}>
                            Tell us what's up. Include any error messages or steps to reproduce if you're reporting a bug.
                        </p>
                        <SupportTicketForm onSubmitted={() => setOpen(false)} onCancel={close} onBusyChange={setBusy} />
                    </div>
                </div>
            )}
        </>
    );
}
